<script setup lang="ts">
import { ref, onMounted } from "vue";
import { useStore } from "@/store/Store";
import { EventBus } from "@/utils/EventBus";
import Modal from "./Modal.vue";

const store = useStore();
const visible = ref(false);

onMounted(() => {
	EventBus.on("moreInfo", () => {
		visible.value = true;
	});
});

</script>


<template>
	<Modal class="more-info" size="m" :show="visible" :closeable="true" @close="visible = false">
		<div class="more-info-content" v-html="store.localized(store.map?.texts, 'moreInfoContent')"></div>
	</Modal>
</template>



<style>
.more-info {
	max-height: 90vh !important;
	max-height: 90svh !important;
	align-self: stretch;
	/* overflow-y: auto; */

	.more-info-content {
		align-self: stretch;
	}

	table {
		width: 100%;
		text-align: center;
		font-size: 14px;
		border-spacing: 0;
	}

	th {
		font-size: .8rem;
		font-weight: bold;
		line-height: .8rem;
		vertical-align: bottom;
		background-color: #333;
		color: white;
		padding: .3rem .2rem;
	}

	tr:nth-child(odd) {
		background-color: #eee;
	}

	td {
		padding: .4rem 0;
		border-top: solid 1px #aaa;

	}

	td:first-child,
	th:first-child {
		text-align: left;
		padding-left: 6px;
	}
}
</style>